// 线下图库地址分类的
let url  = 'https://www.sjxsm.com/uniform/'
// let url = 'http://192.168.1.174:9000/'
export default url